import "./Footer.css"

const Footer = () => {
  const currentYear = new Date().getFullYear()
  const companyName = "Altrange Private Limited"

  return (
    <footer className="website-footer">
      <div className="footer-content">
        <p className="footer-text">
          &copy; {currentYear} {companyName}. All rights reserved.
        </p>
      </div>
    </footer>
  )
}

export default Footer
